import React, {useEffect} from "react"
import InputBox from "./InputBox"

function TitleBar(props) {

    useEffect(() => {
        if (props.state === "start") return
        const element = document.getElementById("titlebar")
        if (!element) return
        element.style.marginBottom = '0'
        requestAnimationFrame(() => {
            element.style.marginBottom = "2rem"
        })
    }, [props.state])

    return (
        <div id="titlebar">
            <h1>LVL UP</h1>
            <InputBox state={props.state} navOpen={props.navOpen} setPrompt={props.setPrompt} showOptions={() => props.showOptions()}/>
        </div>
    )
}

export default TitleBar
